import Header from './Header';

export default Header;



// WEBPACK FOOTER //
// ./src/client/Components/Header/index.js